"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validationReducer;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/map"));
function validationReducer(state, {
  type,
  payload
}) {
  switch (type) {
    case 'addWatchedName':
      {
        const newWatchedNames = new _set.default(state.watchedNames);
        newWatchedNames.add(payload.newWatchedName);
        state = {
          ...state,
          watchedNames: newWatchedNames
        };
        break;
      }
    case 'formModified':
      {
        state = {
          ...state,
          isFormModified: payload.newValue
        };
        break;
      }
    case 'formMount':
      {
        state = {
          ...state,
          eventHandler: payload.eventHandler,
          formElement: payload.formElement
        };
        break;
      }
    case 'formUnmount':
      {
        state = payload.newState;
        break;
      }
    case 'createInputState':
      {
        const newInputStates = new _map.default(state.inputStates);
        newInputStates.set(payload.inputElement, {
          rules: payload.rules,
          errorState: {}
        });
        state = {
          ...state,
          inputStates: newInputStates
        };
        break;
      }
    case 'updateInputStateValue':
      {
        const newInputStates = new _map.default(state.inputStates);
        newInputStates.set(payload.inputElement, {
          ...newInputStates.get(payload.inputElement),
          [payload.stateKey]: payload.newValue
        });
        state = {
          ...state,
          inputStates: newInputStates
        };
        break;
      }
    case 'removeInputState':
      {
        const newInputStates = new _map.default(state.inputStates);
        newInputStates.delete(payload.inputElement);
        state = {
          ...state,
          inputStates: newInputStates
        };
        break;
      }
  }
  return state;
}